'use client';

import React__default, { useCallback } from 'react';
import { SwitcherWrapper, Switch, Toggle } from './Switcher.css.js';

/**
 * Switch Toggle Component
 *
 * @param props
 */
var Switcher = function (props) {
    var _a = props.label, label = _a === void 0 ? '' : _a, _b = props.value, value = _b === void 0 ? false : _b, _c = props.isLabelLeft, isLabelLeft = _c === void 0 ? false : _c, onChange = props.onChange;
    var onChangeSwitch = useCallback(function () {
        var checked = !value;
        onChange && onChange(checked);
    }, [onChange, value]);
    return (React__default.createElement(SwitcherWrapper, { "data-checked": value, isLabelLeft: isLabelLeft, onClick: onChangeSwitch },
        React__default.createElement(Switch, { isChecked: value },
            React__default.createElement(Toggle, { isChecked: value })),
        label ? React__default.createElement("label", null, label) : null));
};

export { Switcher as default };
//# sourceMappingURL=index.js.map
